import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_UTILITY_API_URL } from "../../../../Constants/baseConstant";
import { getUserData } from "../../../Base/helper/baseFunctions";

export const GetSubscriptionHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/plans/getSubscription`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: data.domain || params?.domain,
        }
    })
        .then((res) => {

            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed", hasError: true, data: err?.data }
        })

}
export const UpdateSubscriptionHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/plans/updateSubscription`, {
        method: "PUT",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: data?.domain,
            due_date: params?.due_date,
            planid: params?.planid,
            group_org_boolean: params?.group_org_boolean,
            face_recog_boolean: params?.face_recog_boolean,
            access_payroll: params?.access_payroll,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Updated Successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Failed", hasError: true, data: err?.data }
        })
}

